module.exports = __webpack_public_path__ + "static/media/blog6.6a2ab56a.jpg";